import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/filter.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ef30234a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marketplace-page container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "marketplace-banner mx-md-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "marketplace-banner__title" }, " Проверенные поставщики. Безопасные сделки. "),
  /*#__PURE__*/_createElementVNode("p", { class: "marketplace-banner__subtitle" }, " Выбирайте товары и услуги от компаний, прошедших проверку X-Global. Без посредников, без рисков. ")
], -1))
const _hoisted_3 = { class: "marketplace-page__container d-flex" }
const _hoisted_4 = { class: "marketplace products-container col flex-grow-1" }
const _hoisted_5 = { class: "filters-header flex flex-wrap gap-2 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-down" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-down" }, null, -1))
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-down" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "dropdown-panel price-box absolute top-full left-0 mt-2 z-50",
  ref: "dropdownPanels"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block mb-1 font-semibold text-sm" }, "Цена", -1))
const _hoisted_13 = { class: "price-inputs d-flex gap-2 mb-2" }
const _hoisted_14 = {
  key: 0,
  class: "filter-offcanvas",
  ref: "dropdownPanels"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Фильтр", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Цена", -1))
const _hoisted_17 = { class: "d-flex gap-3 mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Название", -1))
const _hoisted_19 = { class: "text-end mt-4" }
const _hoisted_20 = {
  key: 1,
  class: "dropdown-panel",
  ref: "dropdownPanels"
}
const _hoisted_21 = { class: "categories-dropdown grid grid-cols-3 p-4 bg-white rounded-xl shadow-lg" }
const _hoisted_22 = ["onMouseenter", "onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onMouseenter", "onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 2,
  class: "dropdown-panel price-box absolute top-full left-0 mt-2 z-50",
  ref: "dropdownPanels"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block mb-1 font-semibold text-sm" }, "Регион", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Выберите регион", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "d-flex gap-2 mt-2" }
const _hoisted_34 = { class: "filter-header" }
const _hoisted_35 = { class: "applied-filters" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Примененные фильтры:", -1))
const _hoisted_37 = { class: "filter-tags" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "filter-tag"
}
const _hoisted_40 = {
  key: 1,
  class: "filter-tag"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "product-list grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3" }
const _hoisted_43 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewProductCard = _resolveComponent("NewProductCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "filter-chip",
            style: {"display":"none"},
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleDropdown('main')), ["stop"]))
          }, [
            _hoisted_6,
            _createTextVNode(" Фильтр ")
          ]),
          _createElementVNode("div", {
            class: "dropdown-chip",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleDropdown('category')), ["stop"]))
          }, [
            _createTextVNode(" Категория "),
            _hoisted_7
          ]),
          _createElementVNode("div", {
            class: "dropdown-chip",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleDropdown('region')), ["stop"]))
          }, [
            _createTextVNode(" Регион "),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "dropdown-chip",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleDropdown('price')), ["stop"]))
            }, [
              _createTextVNode(" Цена "),
              _hoisted_10
            ]),
            (_ctx.activeDropdown === 'price')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      placeholder: "От",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.minPrice) = $event)),
                      onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
                    }, null, 544), [
                      [
                        _vModelText,
                        _ctx.minPrice,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      placeholder: "До",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.maxPrice) = $event)),
                      onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
                    }, null, 544), [
                      [
                        _vModelText,
                        _ctx.maxPrice,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "btn-apply",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
                  }, "Готово")
                ], 512))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.activeDropdown === 'main')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["filter-panel", { open: _ctx.activeDropdown === 'main' }])
              }, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "От",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.minPrice) = $event)),
                    onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.minPrice,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "До",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.maxPrice) = $event)),
                    onKeydown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.maxPrice,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control mb-3",
                  placeholder: "Введите название",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "btn btn-primary w-full",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
                  }, " Готово ")
                ])
              ], 2), [
                [_vShow, _ctx.activeDropdown === 'main']
              ]),
              _createElementVNode("div", {
                class: "overlay",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
              })
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.activeDropdown === 'category')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: category.id,
                      onMouseenter: ($event: any) => (_ctx.activeParent = category),
                      onClick: ($event: any) => (_ctx.handleCategoryClick(category)),
                      class: "category-item"
                    }, [
                      _createTextVNode(_toDisplayString(category.name) + " ", 1),
                      (category.childrens?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "›"))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_22))
                  }), 128))
                ]),
                (_ctx.activeParent?.childrens)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeParent.childrens, (sub) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: sub.id,
                          onMouseenter: ($event: any) => (_ctx.activeChild = sub),
                          onClick: ($event: any) => (_ctx.handleCategoryClick(sub)),
                          class: "subcategory-item"
                        }, [
                          _createTextVNode(_toDisplayString(sub.name) + " ", 1),
                          (sub.childrens?.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "›"))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_25))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeChild?.childrens)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeChild.childrens, (sub2) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: sub2.id,
                          onClick: ($event: any) => (_ctx.handleCategoryClick(sub2)),
                          class: "subsubcategory-item"
                        }, _toDisplayString(sub2.name), 9, _hoisted_28))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.activeDropdown === 'region')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                class: "form-control w-full",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedRegionIds) = $event))
              }, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: region.id,
                    value: region.name
                  }, _toDisplayString(region.name), 9, _hoisted_32))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedRegionIds]
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn-apply",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.applyRegion && _ctx.applyRegion(...args)))
                }, "Готово"),
                _createElementVNode("button", {
                  class: "btn-apply",
                  style: {"background":"#eee","color":"#333"},
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clearRegion && _ctx.clearRegion(...args)))
                }, " Сбросить ")
              ])
            ], 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters, (filter) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "filter-tag",
                  key: filter
                }, [
                  _createTextVNode(_toDisplayString(filter) + " ", 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeFilter(filter))
                  }, "×", 8, _hoisted_38)
                ]))
              }), 128)),
              (_ctx.selectedCategoryId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createTextVNode(_toDisplayString(_ctx.getCategoryName(String(_ctx.selectedCategoryId))) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.removeFilter('category')))
                    }, "×")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedRegionIds)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_ctx.selectedRegionIds) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.removeFilter('region')))
                    }, "×")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.pageMeta?.additional_title)
          ? (_openBlock(), _createElementBlock("h4", {
              key: 3,
              class: "meta-additional-title mt-3 mb-3",
              innerHTML: _ctx.pageMeta.additional_title
            }, null, 8, _hoisted_41))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product, index) => {
            return (_openBlock(), _createBlock(_component_NewProductCard, {
              key: index,
              product: product
            }, null, 8, ["product"]))
          }), 128))
        ]),
        (_ctx.pageMeta?.text_field)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "meta-text-field mt-4",
              innerHTML: _ctx.pageMeta.text_field
            }, null, 8, _hoisted_43))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}